<template>
	<transition name="tips-fade">
		<div id="tips" v-show="tipsShow" class="tisp tips-window" :class="tipsClass">
			<div class="tips-icon" aria-hidden="true">
				<svg v-if="type === 'success'" viewBox="0 0 24 24">
					<path d="M9.2 16.6 4.9 12.3l-1.4 1.4 5.7 5.7L21 7.6l-1.4-1.4z" />
				</svg>
				<svg v-else-if="type === 'error'" viewBox="0 0 24 24">
					<path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm3.5 6.9-1.4-1.4L12 9.6 9.9 7.5 8.5 8.9l2.1 2.1-2.1 2.1 1.4 1.4 2.1-2.1 2.1 2.1 1.4-1.4-2.1-2.1 2.1-2.1z" />
				</svg>
				<svg v-else viewBox="0 0 24 24">
					<path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 15h-2v-7h2v7zm0-9h-2V6h2v2z" />
				</svg>
			</div>
			<div class="tips-content">
				<strong v-if="title" class="tips-title">{{ title }}</strong>
				<p v-html="message"></p>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'tipsWindow',
	data() {
		return {
			title: '',
			message: '',
			tipsShow: false,
			type: 'error',
			timer: null
		}
	},
	mounted() { },
	computed: {
		tipsClass() {
			return [
				'tips-window--' + this.type,
				this.title ? 'tips-window--with-title' : 'tips-window--compact'
			];
		}
	},
	methods: {
		show(message, options) {
			const config = typeof options === 'string' ? { type: options } : (options || {});
			clearTimeout(this.timer);
			this.tipsShow = true;
			this.title = config.title || '';
			this.message = message;
			this.type = config.type || 'error';
			const duration = config.duration || 3000;
			this.timer = setTimeout(() => {
				this.tipsShow = false;
			}, duration)
		}
	}
}
</script>
<style scoped>
.tips-window.tisp {
	position: fixed;
	top: 28%;
	left: 50%;
	z-index: 99999;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.12rem;
	width: min(4.35rem, calc(100vw - 0.48rem));
	min-width: 3.2rem;
	padding: 0.52rem 0.34rem 0.3rem;
	box-sizing: border-box;
	color: #283142;
	text-align: center;
	background:
		linear-gradient(180deg, rgba(255, 248, 238, 0.98) 0%, rgba(255, 255, 255, 0.98) 44%, rgba(255, 251, 246, 0.98) 100%);
	border: 0.0125rem solid rgba(255, 229, 196, 0.95);
	border-radius: 0.22rem;
	box-shadow: 0 0.2rem 0.5rem rgba(38, 31, 22, 0.2), inset 0 0.0125rem 0 rgba(255, 255, 255, 0.9);
	opacity: 1;
	transform: translate(-50%, -50%);
	backdrop-filter: blur(10px);
}

.tips-window::before {
	content: '';
	position: absolute;
	left: 50%;
	top: 0;
	width: 1.1rem;
	height: 0.055rem;
	background: #ff8b1f;
	border-radius: 0 0 0.08rem 0.08rem;
	transform: translateX(-50%);
}

.tips-window--success::before {
	background: linear-gradient(90deg, #ff9f2d 0%, #2fc777 42%, #2fc777 58%, #ff9f2d 100%);
}

.tips-window--success.tips-window--with-title {
	border-color: rgba(255, 185, 103, 0.9);
	box-shadow: 0 0.2rem 0.5rem rgba(189, 95, 24, 0.18), 0 0.04rem 0.22rem rgba(255, 149, 38, 0.16);
}

.tips-window--success.tips-window--with-title::after {
	content: '';
	position: absolute;
	left: 0.34rem;
	right: 0.34rem;
	bottom: 0;
	height: 0.045rem;
	background: linear-gradient(90deg, rgba(255, 151, 38, 0) 0%, rgba(255, 151, 38, 0.52) 50%, rgba(255, 151, 38, 0) 100%);
	border-radius: 0.08rem 0.08rem 0 0;
}

.tips-window--error::before {
	background: #ff5a52;
}

.tips-icon {
	display: flex;
	position: absolute;
	top: -0.34rem;
	left: 50%;
	flex: 0 0 0.68rem;
	align-items: center;
	justify-content: center;
	width: 0.68rem;
	height: 0.68rem;
	margin: 0;
	color: #fff;
	background: #ff8b1f;
	border-radius: 50%;
	border: 0.06rem solid #fff;
	box-shadow: 0 0.1rem 0.2rem rgba(255, 139, 31, 0.26);
	transform: translateX(-50%);
}

.tips-window--success .tips-icon {
	background: linear-gradient(180deg, #45d98a 0%, #24b96a 100%);
	box-shadow: 0 0.06rem 0.12rem rgba(36, 185, 106, 0.24);
}

.tips-window--error .tips-icon {
	background: linear-gradient(180deg, #ff7a72 0%, #f24d45 100%);
	box-shadow: 0 0.06rem 0.12rem rgba(242, 77, 69, 0.24);
}

.tips-icon svg {
	width: 0.34rem;
	height: 0.34rem;
	fill: currentColor;
}

.tips-content {
	width: 100%;
}

.tips-title {
	display: block;
	margin-bottom: 0.08rem;
	color: #1f2937;
	font-size: 0.24rem;
	font-weight: 800;
	line-height: 1.25;
}

.tips-window p {
	margin: 0;
	color: #566072;
	font-size: 0.17rem;
	font-weight: 600;
	line-height: 1.6;
	word-break: break-word;
}

.tips-window--error {
	background: rgba(255, 255, 255, 0.98);
	border-color: rgba(255, 202, 199, 0.95);
}

.tips-window--error.tips-window--compact {
	top: 24%;
	flex-direction: row;
	align-items: center;
	width: auto;
	max-width: min(4.8rem, calc(100vw - 0.48rem));
	min-width: 2.8rem;
	padding: 0.18rem 0.24rem;
	text-align: left;
	background: linear-gradient(180deg, #ffffff 0%, #fff8f7 100%);
	border-color: rgba(255, 194, 190, 0.95);
	border-radius: 0.16rem;
	box-shadow: 0 0.14rem 0.34rem rgba(151, 45, 38, 0.18);
	overflow: hidden;
}

.tips-window--error.tips-window--compact::before {
	left: 0;
	top: 0;
	bottom: 0;
	width: 0.055rem;
	height: auto;
	background: #ff5a52;
	border-radius: 0;
	transform: none;
}

.tips-window--error.tips-window--compact .tips-icon {
	position: static;
	flex: 0 0 0.42rem;
	width: 0.42rem;
	height: 0.42rem;
	border: 0;
	background: linear-gradient(180deg, #ff766f 0%, #ef453d 100%);
	box-shadow: 0 0.06rem 0.14rem rgba(239, 69, 61, 0.24);
	transform: none;
}

.tips-window--error.tips-window--compact .tips-icon svg {
	width: 0.25rem;
	height: 0.25rem;
}

.tips-window--error.tips-window--compact p {
	color: #3f2a2a;
	font-size: 0.18rem;
	font-weight: 700;
	line-height: 1.45;
}

.tips-window--error .tips-title,
.tips-window--info .tips-title {
	font-size: 0.21rem;
}

.tips-window--compact {
	flex-direction: row;
	align-items: center;
	width: auto;
	max-width: min(4.8rem, calc(100vw - 0.48rem));
	min-width: 2.6rem;
	padding: 0.2rem 0.28rem;
	overflow: hidden;
	text-align: left;
}

.tips-window--compact::before {
	left: 0;
	top: 0;
	bottom: 0;
	width: 0.055rem;
	height: auto;
	border-radius: 0;
	transform: none;
}

.tips-window--compact .tips-icon {
	position: static;
	flex: 0 0 0.42rem;
	width: 0.42rem;
	height: 0.42rem;
	border: 0;
	transform: none;
}

.tips-window--compact .tips-icon svg {
	width: 0.24rem;
	height: 0.24rem;
}

.tips-window--compact p {
	font-size: 0.18rem;
	color: #283142;
}

.tips-fade-enter-active {
	animation: tips-in 0.22s ease-out;
}

.tips-fade-leave-active {
	transition: opacity 0.16s ease, transform 0.16s ease;
}

.tips-fade-leave-to {
	opacity: 0;
	transform: translate(-50%, calc(-50% - 0.12rem));
}

@keyframes tips-in {
	0% {
		opacity: 0;
		transform: translate(-50%, calc(-50% - 0.16rem)) scale(0.96);
	}

	100% {
		opacity: 1;
		transform: translate(-50%, -50%) scale(1);
	}
}

@media (max-width: 767px) {
	.tips-window.tisp {
		top: 28%;
		gap: 0.16rem;
		width: calc(100vw - 1.12rem);
		min-width: 0;
		padding: 0.78rem 0.42rem 0.38rem;
		border-radius: 0.34rem;
	}

	.tips-window::before {
		width: 1.5rem;
		height: 0.08rem;
		border-radius: 0 0 0.12rem 0.12rem;
	}

	.tips-icon {
		top: -0.46rem;
		flex-basis: 0.92rem;
		width: 0.92rem;
		height: 0.92rem;
		border-width: 0.08rem;
	}

	.tips-icon svg {
		width: 0.48rem;
		height: 0.48rem;
	}

	.tips-title {
		margin-bottom: 0.12rem;
		font-size: 0.4rem;
	}

	.tips-window p {
		font-size: 0.28rem;
		line-height: 1.5;
	}

	.tips-window--compact {
		flex-direction: row;
		align-items: center;
		gap: 0.2rem;
		width: calc(100vw - 1.12rem);
		max-width: none;
		min-width: 0;
		padding: 0.28rem 0.34rem;
		border-radius: 0.28rem;
		overflow: hidden;
		text-align: left;
	}

	.tips-window--compact::before {
		width: 0.08rem;
		border-radius: 0;
	}

	.tips-window--compact .tips-icon {
		position: static;
		flex-basis: 0.58rem;
		width: 0.58rem;
		height: 0.58rem;
		border: 0;
		transform: none;
	}

	.tips-window--compact .tips-icon svg {
		width: 0.34rem;
		height: 0.34rem;
	}

	.tips-window--compact p {
		font-size: 0.3rem;
	}

	.tips-window--error.tips-window--compact {
		top: 20%;
		width: calc(100vw - 1.1rem);
		max-width: none;
		min-width: 0;
		padding: 0.26rem 0.34rem;
		border-radius: 0.28rem;
	}

	.tips-window--error.tips-window--compact::before {
		width: 0.08rem;
		border-radius: 0.28rem 0 0 0.28rem;
	}

	.tips-window--error.tips-window--compact .tips-icon {
		flex-basis: 0.58rem;
		width: 0.58rem;
		height: 0.58rem;
	}

	.tips-window--error.tips-window--compact .tips-icon svg {
		width: 0.34rem;
		height: 0.34rem;
	}

	.tips-window--error.tips-window--compact p {
		font-size: 0.3rem;
	}
}
</style>
